import moment from 'moment';

export default class LocationDataHelper {
  constructor() {}

  isSameSeries(one, two) {
    return one && one.last && one.last.t && two && two.last && two.last.t === one.last.t;
  }
  isAssetPinned(gpsSeriesAttrs = {}) {
    return !!gpsSeriesAttrs['onei3:disable_data'];
  }
  daysSinceCommunicated(date) {
    return moment().diff(moment(date), 'days', true);
  }
  isValidGpsSeries(gpsSeries = {}) {
    return gpsSeries.last && Array.isArray(gpsSeries.last.v);
  }
  getAssetGpsStatus(gpsSeries, isTseriesAsset) {
    const {last, attrs} = gpsSeries || {};

    if (!this.isValidGpsSeries(gpsSeries)) {
      return 'no-gps';
    }

    if (this.isAssetPinned(attrs)) {
      return 'pinned-gps';
    }

    if (isTseriesAsset) {
      return 'bluetooth-gps';
    }

    if (this.daysSinceCommunicated(last.t) > 30) {
      return 'no-gps-in-30d';
    }

    return 'gps-in-30d';
  }

  getGpsCoordinatesByPage(currentPage, pageSize, data = []) {
    const begin = (currentPage - 1) * pageSize;
    const end = begin + pageSize;
    return data.slice(begin, end);
  }
}
